import Actions from './action';
export const initState = {
	affiliateUsageTotalVisit: 0,
	affiliateUsageTotalVisitLoading: true,
	affiliateUsageAverageTotalVisit: 0,
	affiliateUsageAverageTotalVisitLoading: true,
	affiliateUsageChartdataLoading: true,
	affiliateUsageChartdata: [],
	affiliateUsageTabledataLoading: true,
	affiliateUsageTabledata: [],
	affiliateUsageDropdown: [],
};

const affiliateReducer = (state = initState, action) => {
	switch (action.type) {
		case Actions.types.GET_AFFILIATE_USAGE_TOTAL_VISIT_STARTED: {
			return {
				...state,
				affiliateUsageTotalVisitLoading: true,
			};
		}
		case Actions.types.GET_AFFILIATE_USAGE_TOTAL_VISIT_SUCCESS: {
			return {
				...state,
				affiliateUsageTotalVisitLoading: false,
				affiliateUsageTotalVisit: action.visitCount,
			};
		}
		case Actions.types.GET_AFFILIATE_USAGE_TOTAL_VISIT_FAIL: {
			return {
				...state,
				affiliateUsageTotalVisitLoading: false,
				affiliateUsageTotalVisit: 0,
			};
		}

		case Actions.types.GET_AFFILIATE_USAGE_AVERAGE_LENGTH_VISIT_STARTED: {
			return {
				...state,
				affiliateUsageAverageTotalVisitLoading: true,
			};
		}
		case Actions.types.GET_AFFILIATE_USAGE_AVERAGE_LENGTH_VISIT_SUCCESS: {
			return {
				...state,
				affiliateUsageAverageTotalVisitLoading: false,
				affiliateUsageAverageTotalVisit: action.visitCount,
			};
		}
		case Actions.types.GET_AFFILIATE_USAGE_AVERAGE_LENGTH_VISIT_FAIL: {
			return {
				...state,
				affiliateUsageAverageTotalVisitLoading: false,
				affiliateUsageAverageTotalVisit: 0,
			};
		}
		case Actions.types.GET_AFFILIATE_CHART_DATA_STARTED: {
			return {
				...state,
				affiliateUsageChartdataLoading: true,
			};
		}
		case Actions.types.GET_AFFILIATE_CHART_DATA_SUCCESS: {
			return {
				...state,
				affiliateUsageChartdataLoading: false,
				affiliateUsageChartdata: action.response,
				affiliateUsageDropdown: action.affiliateUsageDropdown,
			};
		}
		case Actions.types.GET_AFFILIATE_CHART_DATA_FAIL: {
			return {
				...state,
				affiliateUsageChartdataLoading: false,
				affiliateUsageChartdata: [],
				affiliateUsageDropdown: [],
			};
		}
		case Actions.types.GET_AFFILIATE_TABLE_DATA_STARTED: {
			return {
				...state,
				affiliateUsageTabledataLoading: true,
			};
		}
		case Actions.types.GET_AFFILIATE_TABLE_DATA_SUCCESS: {
			return {
				...state,
				affiliateUsageTabledataLoading: false,
				affiliateUsageTabledata: action.response,
			};
		}
		case Actions.types.GET_AFFILIATE_TABLE_DATA_FAIL: {
			return {
				...state,
				affiliateUsageTabledataLoading: false,
				affiliateUsageTabledata: [],
			};
		}
		default:
			return state;
	}
};

export default affiliateReducer;
